/**
 * src/api/resumenSemanal.js
 * Resumen semanal por email (H0 · Lote 5) — operación desde el panel.
 *
 * El correo sale solo los viernes a las 12:00 de Chile. Estas funciones son para
 * los dos casos en que no basta con esperar: ver qué pasó, y volver a lanzarlo.
 */
import api from './client'

// Registro de envíos: una fila por (tenant, semana) con su estado. Es donde se ve
// si el viernes salió bien, y para quién no.
export const listarEnvios = (params = {}) =>
  api.get('/admin/resumen-semanal/envios', { params }).then(r => r.data)

// Lanza el envío REAL ahora. Sin clienteId recorre todos los tenants activos,
// igual que el job, respetando el candado (quien ya lo recibió no lo recibe otra
// vez). Con clienteId + forzar reenvía una semana ya cerrada — el tenant que falló.
export const ejecutarResumen = ({ clienteId = '', forzar = false } = {}) =>
  api.post('/admin/resumen-semanal/ejecutar',
    { cliente_id: clienteId, forzar },
    { timeout: 120_000 }).then(r => r.data)

/**
 * El correo tal cual saldría para ese tenant. **No envía nada.**
 *
 * ⚠️ **Devuelve HTML, no JSON**, y por eso lleva `responseType: 'text'`: sin él,
 * axios intenta interpretar la respuesta con el `Content-Type: application/json`
 * que el cliente pone por defecto y el cuerpo llega convertido en algo que no es
 * el correo.
 *
 * ⚠️⚠️ **Y no toma semana, aunque el botón viva en una fila que sí tiene una.** El
 * endpoint (`resumen_semanal.py:143`) construye el informe de AHORA: no existe
 * forma de pedirle el correo de una semana pasada. Pulsar en la fila de
 * `2026-W38` enseña el correo de hoy, no el de aquella semana. Quien pinte esto
 * tiene que decirlo en pantalla — un panel titulado con la semana de la fila
 * sería una mentira por colocación.
 */
export const vistaPreviaResumen = clienteId =>
  api.get('/admin/resumen-semanal/vista-previa', {
    params: { cliente_id: clienteId },
    responseType: 'text',
    timeout: 60_000,
  }).then(r => r.data)

/**
 * Manda el resumen REAL de un tenant a UNA dirección.
 *
 * 🔴 **Esto escribe a una persona.** No toca el registro de la semana ni la huella
 * de precios —probar no puede dejar al tenant sin su envío—, pero el correo sale
 * de verdad. Los dos argumentos son obligatorios y sin valor por defecto: no hay
 * ninguna dirección que sea razonable asumir.
 */
export const enviarPruebaResumen = (clienteId, email) =>
  api.post('/admin/resumen-semanal/prueba',
    { cliente_id: clienteId, email },
    { timeout: 60_000 }).then(r => r.data)
